import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
// import { useTranslation } from "react-i18next";
import DatePicker from 'react-datepicker';
import { motion } from "framer-motion";
import 'react-datepicker/dist/react-datepicker.css';
import "./index.scss";

import DropDown from '../../../../components/ui/DropDown';
import Button from "../../../../components/ui/Button";
import RadioButton from "../../../../components/ui/RadioButton";

import { getloggedInUserType } from "../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getCustomersList, getOrganizationList, getDomainList, getScanHistory, getDownloadExcelDocument, resetDownloadReportResponse, getDownloadPdfDocument } from "../../../../store/actions/reportsAction";
import { getSubdomainList, resetSubdomainList } from "../../../../store/actions/scanInfoAction";
import { toaster } from "../../../../components/ui/Toaster";

const optionsExcel = [
    { label: "Asset Discovery", value: "assetDiscovery", id:"assetDiscovery" },
    { label: "Corporate Email Risk", value: "corporateEmailRisk", id:"corporateEmailRisk" },
    { label: "Concerning Exposures", value: "concerningExposure", id:"concerningExposure" },
    { label: "External Detected Vulnerabilities", value: "externalDetectedVulnerabilities", id:"externalDetectedVulnerabilities" },
    { label: "Dark Web", value: "darkWeb", id:"darkWeb" },
    { label: "Brand Insight", value: "brandInsight", id:"brandInsight" },
];

const optionsPdf = [
    { label: "Executive Summary", value: "executiveSummary", id:"executiveSummary" },
    { label: "Full Report", value: "fullReport", id:"fullreport" }
];

const allValue = {
    id: "all",
    name: "All",
    value: "all",
    logo: null,
    label: "All",
    domain: "All"
};

const ExposureManagementReports = ({currentPageType="default", closeDownloadReport}) => {

    const customersListResponse = useSelector((state) => state.reports?.customerList);
    const organizationListResponse = useSelector((state) => state.reports?.organizationList);
    const domainListResponse = useSelector((state) => state.reports?.domainList);
    const scanHistoryResponse = useSelector((state) => state.reports?.scanHistoryList);
    const subdomainListResponse = useSelector((state) => state.scanInfo?.subdomainList);
    const downloadExcelReportResponse = useSelector((state) => state?.reports?.downloadExcelReport);
    const downloadPdfReportResponse = useSelector((state) => state?.reports?.downloadpdfReport);

    // const { t } = useTranslation();

    const dispatch = useDispatch();

    const [customersList, setCustomersList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("all");
    const [customerSearch, setCustomerSearch] = useState("");
    const [customerSearchLoading, setCustomerSearchLoading] = useState(false);
    const [customerCurrentPage, setCustomerCurrentPage] = useState(1);
    const [customerPageLoading, setCustomerPageLoading] = useState(false);
    const [customerTotalPage, setCustomerTotalPage] = useState(0);

    const [organizationList, setOrganizationList] = useState([]);
    const [selectedOrganization, setSelectedOrganization] = useState("all");
    const [organizationSearch, setOrganizationSearch] = useState("");
    const [organizationSearchLoading, setOrganizationSearchLoading] = useState(false);
    const [organizationCurrentPage, setOrganizationCurrentPage] = useState(1);
    const [organizationPageLoading, setOrganizationPageLoading] = useState(false);
    const [organizationTotalPage, setOrganizationTotalPage] = useState(0);

    const [domainList, setDomainList] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState("");
    const [domainSearch, setDomainSearch] = useState("");
    const [domainSearchLoading, setDomainSearchLoading] = useState(false);
    const [domainCurrentPage, setDomainCurrentPage] = useState(1);
    const [domainPageLoading, setDomainPageLoading] = useState(false);
    const [domainTotalPage, setDomainTotalPage] = useState(0);

    const [subdomainList, setSubdomainList] = useState([]);
    const [selectedSubdomain, setSelectedSubdomain] = useState("");
    const [subdomainSearch, setsubdomainSearch] = useState("");
    const [subdomainSearchLoading, setSubdomainSearchLoading] = useState(false);
    const [subdomainCurrentPage, setSubdomainCurrentPage] = useState(1);
    const [subdomainPageLoading, setSubdomainPageLoading] = useState(false);
    const [subdomainTotalPage, setSubdomainTotalPage] = useState(0);

    const [selectedDate, setSelectedDate] = useState(null);
    const [availableDates, setAvailabelDates] = useState([]);
    const [scanHistoryCurrentPage, setScanHistoryCurrentPage] = useState(1);
    const [selectedScanId, setSelectedScanId] = useState("");

    const [downloadFileOption, setDownloadFileOption] = useState("excel");
    const [selectedModuleOption, setSelectedModuleOption] = useState(optionsExcel);
    const [selectedModulePdfOption, setSelectedModulePdfoption] = useState("")

    const [pdfOptions, setPdfOptions] = useState(optionsPdf)

    const [downloadLoading, setdownloadLoading] = useState(false)    

    const CalenderIcon = () => {
        return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66663 1.6665V4.1665" stroke="#00308B" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.3334 1.6665V4.1665" stroke="#00308B" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.91663 7.57471H17.0833" stroke="#00308B" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.5 7.08317V14.1665C17.5 16.6665 16.25 18.3332 13.3333 18.3332H6.66667C3.75 18.3332 2.5 16.6665 2.5 14.1665V7.08317C2.5 4.58317 3.75 2.9165 6.66667 2.9165H13.3333C16.25 2.9165 17.5 4.58317 17.5 7.08317Z" stroke="#00308B" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.079 11.4167H13.0864" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.079 13.9167H13.0864" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.9962 11.4167H10.0037" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.9962 13.9167H10.0037" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.91197 11.4167H6.91945" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.91197 13.9167H6.91945" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    }

    const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
        <input
            ref={ref}
            value={value}
            onClick={onClick}
            readOnly // Make the input non-editable
            className="form-control date-height"
            placeholder="Select a date"
        />
    ));

    const isAvailableDate = (date) => {
        return availableDates.some(
            (availableDate) => availableDate.toDateString() === date.toDateString()
        );
    };

    // Highlight available dates
    const highlightAvailableDates = (date) => {
        return isAvailableDate(date) ? "highlighted-date" : undefined;
    };

    const changeScannedDate = (date) => {
        setSelectedDate(date)
        let selectedData = new Date(date)
        let index = availableDates.findIndex(date => date.getDate() === selectedData.getDate());
        setSelectedScanId(scanHistoryResponse?.results[index].scan_id)
    }

    const excelOptionChange = (data) => {
        setSelectedModuleOption(data)
    }

    const downloadReport = () => {
        const organization = selectedOrganization && selectedOrganization.toLowerCase() !== "all" ? `&organization_id=${selectedOrganization}` : "";
        const domain = selectedDomain && selectedDomain.toLowerCase() !== "all" ? `&domain=${selectedDomain}` : "";
        const scanId = selectedScanId ? `&scan_id=${selectedScanId}` : "";
        const subdomain = selectedSubdomain ? `&subdomain=${selectedSubdomain}` : "";
        const moduleOption = `&asset_discovery=${selectedModuleOption.some((data)=> data?.value === "assetDiscovery")}&corporate_email_risk=${selectedModuleOption.some((data)=> data?.value === "corporateEmailRisk")}&concerning_exposure=${selectedModuleOption.some((data)=> data?.value === "concerningExposure")}&external_detected_vulnerability=${selectedModuleOption.some((data)=> data?.value === "externalDetectedVulnerabilities")}&dark_web=${selectedModuleOption.some((data)=> data?.value === "darkWeb")}&brand_insight=${selectedModuleOption.some((data)=> data?.value === "brandInsight")}`;
        const selectedOrgName = organizationList.find(
            (option) => option.value === selectedOrganization
        );
        const reportName = `${selectedDomain.toLowerCase() === "all" ? `${selectedOrgName.name}_full_reports.xlsx` : `${selectedDomain}_full_reports.xlsx`}`
        if(downloadFileOption === "excel") {
            const excelUrl = `${organization}${domain}${scanId}${subdomain}${moduleOption}`;
            setdownloadLoading(true)
            dispatch(getDownloadExcelDocument(excelUrl, reportName))
        } else {
            const pdfUrl = `${domain}${scanId}`;
            setdownloadLoading(true)
            dispatch(getDownloadPdfDocument(pdfUrl, selectedDomain, selectedModulePdfOption))
        }        
    }

    const fetchSubDomainList = useCallback(()=>{
        const baseUrl = `&page=${subdomainCurrentPage}&page_size=10`;
        const queryParams = subdomainSearch ? `&query=${subdomainSearch}` : "";
        const organization = selectedOrganization && selectedOrganization.toLowerCase() !== "all" ? `&organization_id=${selectedOrganization}` : '';
        const domain = selectedDomain && selectedDomain.toLowerCase() !== "all" ? `&domain=${selectedDomain}&scan_id=${selectedScanId}` : '';
        const url  = `${baseUrl}${queryParams}${organization}${domain}`
        dispatch(getSubdomainList(url))
    },[dispatch, selectedOrganization, selectedDomain, selectedScanId, subdomainSearch, subdomainCurrentPage])

    const fetchScanHistory = useCallback(()=>{
        if(selectedDomain) {
            let url = `&domain=${selectedDomain}&page=${scanHistoryCurrentPage}&page_size=50`;
            dispatch(getScanHistory(url))
        }        
    },[dispatch, scanHistoryCurrentPage, selectedDomain])

    const fetchDomain = useCallback(()=>{
        const baseUrl = `&page=${domainCurrentPage}&page_size=10`;
        const queryParams = domainSearch ? `&query=${domainSearch}` : "";
        const customer = selectedCustomer && selectedCustomer.toLowerCase() !== "all" ? `&customer_id=${selectedCustomer}` : "";
        const organization = selectedOrganization && selectedOrganization.toLowerCase() !== "all" ? `&organization_id=${selectedOrganization}` : "";
        const url = `${baseUrl}${queryParams}${customer}${organization}` 
        dispatch(getDomainList(url))
    },[dispatch, domainSearch, selectedCustomer, selectedOrganization, domainCurrentPage])

    const fetchOrganizations = useCallback(()=>{        
        const baseUrl = `&page=${organizationCurrentPage}&page_size=10`;
        const queryParams = organizationSearch ? `&query=${organizationSearch}` : "";
        const customer = selectedCustomer && selectedCustomer.toLowerCase() !== "all" ? `&customer_id=${selectedCustomer}` : "";
        const url = `${baseUrl}${queryParams}${customer}`
        dispatch(getOrganizationList(url));
    },[dispatch, organizationSearch, selectedCustomer, organizationCurrentPage])

    const fetchCustomersList = useCallback(()=>{        
        const baseUrl = `&page=${customerCurrentPage}&page_size=10`;
        const queryParams = customerSearch ? `&query=${customerSearch}` : "";
        const url = `${baseUrl}${queryParams}`
        dispatch(getCustomersList(url))
    },[dispatch, customerSearch, customerCurrentPage])

    const checkButtonDisable = () => {
        if(downloadFileOption === "excel") {
            if(selectedOrganization.toLowerCase() === "all") {
                return selectedDomain === ""
            }
            return false
        } else {
            return selectedDomain.toLowerCase() === "all" || selectedModulePdfOption === ""
        }
    }

    useEffect(()=>{        
        if(selectedDomain.toLowerCase() === "all") {
            setPdfOptions([])
            setSelectedModulePdfoption("")
        } else {
            setPdfOptions(optionsPdf)
        }
    },[selectedDomain, selectedModulePdfOption])

    useEffect(()=>{
        if(getloggedInUserType() === "internal") {
            fetchCustomersList()
        } else {
            fetchOrganizations()
        }
        
    },[fetchCustomersList, fetchOrganizations])

    useEffect(()=>{
        fetchOrganizations()
    },[fetchOrganizations, selectedCustomer])

    useEffect(()=>{
        fetchDomain()
    },[fetchDomain, selectedCustomer, selectedOrganization])

    useEffect(()=>{
        fetchScanHistory()
    },[fetchScanHistory, selectedDomain])

    useEffect(()=>{
        fetchSubDomainList()
    },[fetchSubDomainList, selectedDomain, selectedOrganization])

    useEffect(()=>{
        if(customersListResponse !== null) {
            setCustomerSearchLoading(false)
            setCustomerPageLoading(false)
            let list = customersListResponse?.results.map((data)=>{
                return {
                    id: data.customer_id,
                    name: data.name,
                    value: data.customer_id,
                    logo: data.logo,
                    label: data.name
                }
            })
            let finalList = [allValue, ...list]
            setCustomersList((prevList) => {
                const uniqueList = [...prevList, ...finalList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setCustomerTotalPage(customersListResponse?.meta?.total_pages)
        }
    },[customersListResponse])

    useEffect(()=>{        
        if(organizationListResponse !== null) {
            setOrganizationSearchLoading(false)
            setOrganizationPageLoading(false)
            const list = organizationListResponse?.results.map((data) => ({
                id: data.organization_id,
                name: data.name,
                value: data.organization_id,
                logo: data.logo,
                label: data.name,
            }));            
            if(selectedCustomer.toLowerCase() === "all") {
                setOrganizationList([allValue]);
            } else {
                let finalList = [allValue, ...list]
                setOrganizationList((prevList) => {
                    const uniqueList = [...prevList, ...finalList].reduce((acc, item) => {
                        if (!acc.some(existingItem => existingItem.id === item.id)) {
                            acc.push(item);
                        }
                        return acc;
                    }, []);
                    return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
                });
                setOrganizationTotalPage(organizationListResponse?.meta?.total_pages)
            }
                    
        }
    },[organizationListResponse, selectedCustomer])

    useEffect(() => {
        if (domainListResponse !== null) {
            setDomainSearchLoading(false)
            setDomainPageLoading(false)
            const list = domainListResponse.results
                .filter(data => data?.last_scan_detail?.scan_id) // Filter out items with null scan_id
                .map(data => ({
                    id: data.domain_id,
                    name: data.domain,
                    value: data.domain,
                    logo: data.logo,
                    label: data.domain,
                    domain: data.domain,
                    lastScanDetails: data.last_scan_detail
                }));
            // setDomainList(list);         
            if(list.length > 0) {
                if(selectedOrganization.toLowerCase() === "all") { 
                    setDomainList((prevList) => {
                        const uniqueList = [...prevList, ...list].reduce((acc, item) => {
                            if (!acc.some(existingItem => existingItem.id === item.id)) {
                                acc.push(item);
                            }
                            return acc;
                        }, []);
                        return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
                    });
                    setDomainTotalPage(domainListResponse?.meta?.total_pages)
                    if(selectedDomain === ""){
                        setSelectedDomain(list[0]?.value)
                        setSelectedDate(list[0]?.lastScanDetails?.created_at)
                        setSelectedScanId(list[0]?.lastScanDetails?.scan_id)
                        setSelectedSubdomain("")
                    }
                    
                }

                if(selectedOrganization !== "" && selectedOrganization.toLowerCase() !== "all") {
                    let finalList = [allValue, ...list]
                    setDomainList((prevList) => {
                        const uniqueList = [...prevList, ...finalList].reduce((acc, item) => {
                            if (!acc.some(existingItem => existingItem.id === item.id)) {
                                acc.push(item);
                            }
                            return acc;
                        }, []);
                        return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
                    });
                    setDomainTotalPage(domainListResponse?.meta?.total_pages)
                    if(selectedDomain === "") {
                        setSelectedDomain("all")
                        setSelectedDate("")
                        setSelectedScanId("")
                        setSelectedSubdomain("")
                    }
                    
                }                
            } else {
                setDomainList(list)                
                setDomainTotalPage(domainListResponse?.meta?.total_pages)
                setSelectedDomain("")
                setSelectedDate("")
                setSelectedScanId("")
                setSelectedSubdomain("")
            }
        }
    }, [domainListResponse, selectedOrganization, domainSearch, selectedDomain]);

    useEffect(()=>{
        if(scanHistoryResponse != null) {
            if(scanHistoryResponse?.results?.length > 0) {
                if(scanHistoryResponse?.meta?.total_pages > scanHistoryCurrentPage){
                    let dates = scanHistoryResponse?.results.map((dates)=>{
                        return new Date(dates.created_at.replace(" ", "T"))
                    })
                    setAvailabelDates(prev => [...prev, ...dates]);
                    setScanHistoryCurrentPage(prevPage => prevPage + 1)
                } else {
                    let dates = scanHistoryResponse?.results.map((dates)=>{
                        return new Date(dates.created_at.replace(" ", "T"))
                    })
                    setAvailabelDates(prev => [...prev, ...dates])  
                }                
            }
        }
    },[scanHistoryResponse, scanHistoryCurrentPage])

    useEffect(()=>{
        if(subdomainListResponse !== null) {
            setSubdomainSearchLoading(false)
            setSubdomainPageLoading(false)
            if(subdomainListResponse?.results?.length > 0) {
                const list = subdomainListResponse?.results.map((data) => ({
                    id: data.id,
                    name: data.subdomain,
                    value: data.subdomain,
                    label: data.subdomain,
                }));
                setSubdomainList((prevList) => {
                    const uniqueList = [...prevList, ...list].reduce((acc, item) => {
                        if (!acc.some(existingItem => existingItem.id === item.id)) {
                            acc.push(item);
                        }
                        return acc;
                    }, []);
                    return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
                });
                setSubdomainTotalPage(subdomainListResponse?.meta?.total_pages)
                if(subdomainListResponse?.status === "failed") {
                    setSubdomainList([])
                }
            }            
            dispatch(resetSubdomainList())
        }
    },[subdomainListResponse, dispatch])

    useEffect(()=>{
        if(downloadExcelReportResponse !== null) {
            if (downloadExcelReportResponse?.status === "success") {
                toaster.addToast("Reports Downloaded successfully", "success");
                setdownloadLoading(false)
            } else if (downloadExcelReportResponse?.status === "failed") {
                toaster.addToast(downloadExcelReportResponse?.message || "Failed to Download", "error");
                setdownloadLoading(false)
            }       
            dispatch(resetDownloadReportResponse())
        }
    },[downloadExcelReportResponse, dispatch])

    useEffect(() => {
        if(downloadPdfReportResponse !== null) {
            if (downloadPdfReportResponse?.status === "success") {
                toaster.addToast("Reports Downloaded successfully", "success");
                setdownloadLoading(false)
            } else if (downloadPdfReportResponse?.status === "failed") {
                toaster.addToast(downloadPdfReportResponse?.message || "Failed to Download", "error");
                setdownloadLoading(false)
            }
            dispatch(resetDownloadReportResponse())
        }
    }, [downloadPdfReportResponse, dispatch]);

    return (
        <>  
            {currentPageType === "header" &&<div className="modal-header mt-4">
                <h2>Download Report</h2>
            </div>}       
            <div className="add-exposure-container reports-container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <Row>
                        {getloggedInUserType() === "internal" && <Col lg={currentPageType === "header" ? 12 : 6}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container">
                                    <p className="mb-1">Customer</p>
                                    <DropDown
                                        options={customersList}
                                        placeHolder="Select Customer"
                                        onChange={(e) => {
                                            setSelectedCustomer(e.value)
                                            setSelectedOrganization("all")                                                                    
                                        }}
                                        searchType={"server"}                                    
                                        selectedValue={selectedCustomer}
                                        defaultSelectedValue={selectedCustomer}
                                        dropDownType = {"scanInfo"}
                                        imageType = {"customer"}
                                        isSearchable
                                        updateSearchValue={(data) => {
                                            setCustomersList([])
                                            setCustomerSearchLoading(true)
                                            setCustomerSearch(data)
                                            setCustomerCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                                        }}
                                        isSearchLoading={customerSearchLoading}
                                        onScrollEnd = {()=>{
                                            if(!customerPageLoading && (customerTotalPage > customerCurrentPage)) {
                                                setCustomerPageLoading(true)
                                                setCustomerCurrentPage((prevPage) => prevPage + 1)
                                            }
                                        }}
                                        pageLoading={customerPageLoading}
                                    />
                                </div>
                            </div>
                        </Col>}
                        <Col lg={currentPageType === "header" ? 12 : 6}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container">
                                    <p className="mb-1">Organization</p>
                                    <DropDown
                                        options={organizationList}
                                        placeHolder="Select Organization"
                                        onChange={(e) => {
                                            setSelectedOrganization(e.value)                                  
                                        }}
                                        searchType={"server"}                                    
                                        selectedValue={selectedOrganization}
                                        defaultSelectedValue={selectedOrganization}
                                        dropDownType = {"scanInfo"}
                                        imageType = {"organization"}
                                        isSearchable
                                        updateSearchValue={(data) => {
                                            setOrganizationList([])
                                            setOrganizationSearchLoading(true)
                                            setOrganizationSearch(data)
                                            setOrganizationCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                                        }}
                                        isSearchLoading={organizationSearchLoading}
                                        onScrollEnd = {()=>{
                                            if(!organizationPageLoading && (organizationTotalPage > organizationCurrentPage)) {
                                                setOrganizationPageLoading(true)
                                                setOrganizationCurrentPage((prevPage) => prevPage + 1)
                                            }
                                        }}
                                        pageLoading={organizationPageLoading}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col lg={currentPageType === "header" ? 12 : 6}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container">
                                    <p className="mb-1">Domain</p>
                                    <DropDown
                                        options={domainList}
                                        placeHolder="Select Domain"
                                        onChange={(e) => {
                                            setSelectedDomain(e.name)
                                            setSelectedDate(e?.lastScanDetails?.created_at)
                                            setSelectedScanId(e?.lastScanDetails?.scan_id)
                                            setSelectedSubdomain("")
                                            setScanHistoryCurrentPage(1);
                                            setAvailabelDates([])
                                        }}
                                        searchType={"server"}                                    
                                        selectedValue={selectedDomain}
                                        defaultSelectedValue={selectedDomain}
                                        dropDownType = {"scanInfo"}
                                        imageType = {"domain"}
                                        resetValue = {selectedDomain === "" ? true : false}
                                        isSearchable
                                        updateSearchValue={(data) => {
                                            setDomainList([])
                                            setDomainSearchLoading(true)
                                            setDomainSearch(data)
                                            setDomainCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                                        }}
                                        isSearchLoading={domainSearchLoading}
                                        onScrollEnd = {()=>{
                                            if(!domainPageLoading && (domainTotalPage > domainCurrentPage)) {
                                                setDomainPageLoading(true)
                                                setDomainCurrentPage((prevPage) => prevPage + 1)
                                            }
                                        }}
                                        pageLoading={domainPageLoading}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col lg={currentPageType === "header" ? 12 : 6}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container date-picker-container report-info-datepicker">
                                    <p className="mb-1">Select Date (only applicable for specific domain)</p>
                                    <DatePicker
                                        showIcon
                                        selected={selectedDate}
                                        onChange={changeScannedDate}
                                        filterDate={isAvailableDate} // Enable only available dates
                                        dayClassName={highlightAvailableDates} // Highlight available dates
                                        placeholderText="Select an date"
                                        icon={CalenderIcon()}
                                        dateFormat="MMM dd, yyyy"
                                        customInput={<CustomDateInput />}
                                        maxDate={new Date()}
                                        className="custom-width-datepicker"
                                    >
                                        <div className="additional-content">
                                            <div className="selected-date"><span></span>Selected Date</div>
                                            <div className="scanned-date"><span></span>Scanned Date</div>
                                        </div>
                                    </DatePicker>
                                </div>
                            </div>
                        </Col>
                        <Col lg={currentPageType === "header" ? 12 : 6}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container">
                                    <p className="mb-1">Subdomain (only applicable after selecting date)</p>
                                    <DropDown
                                        options={subdomainList}
                                        placeHolder="Select subdomain"
                                        onChange={(e)=>{
                                            setSelectedSubdomain(e.name)
                                        }}                                    
                                        selectedValue={selectedSubdomain}
                                        resetValue = {selectedSubdomain === "" ? true : false}
                                        dropDownType ={"reportSubdomain"}
                                        searchType={"server"}
                                        isSearchable
                                        disabled={downloadFileOption === "pdf"}
                                        updateSearchValue={(data) => {
                                            setSubdomainList([])
                                            setSubdomainSearchLoading(true)
                                            setsubdomainSearch(data)
                                            setSubdomainCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                                        }}
                                        isSearchLoading={subdomainSearchLoading}
                                        onScrollEnd = {()=>{
                                            if(!subdomainPageLoading && (subdomainTotalPage > subdomainCurrentPage)) {
                                                setSubdomainPageLoading(true)
                                                setSubdomainCurrentPage((prevPage) => prevPage + 1)
                                            }
                                        }}
                                        pageLoading={subdomainPageLoading}
                                    />
                                </div>
                            </div>                               
                        </Col>
                        <Col lg={currentPageType === "header" ? 12 : 6}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container">
                                    <p className="mb-1">Select Format</p>
                                    <div className="d-flex gap-5 mt-3">
                                        <RadioButton radioId={"excel"} radioLabel={"Excel"} radioValue={"excel"} onChange={(data)=>setDownloadFileOption(data)} isChecked={downloadFileOption === "excel"}/>
                                        <RadioButton radioId={"pdf"} radioLabel={"PDF"} radioValue={"pdf"} onChange={(data)=>setDownloadFileOption(data)} isChecked={downloadFileOption === "pdf"}/>                                    
                                    </div>                                
                                </div>
                            </div>
                        </Col>
                        {downloadFileOption === "pdf" && <Col lg={currentPageType === "header" ? 12 : 6}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container">
                                    <p className="mb-1">PDF Option</p>
                                    <DropDown
                                        options={pdfOptions}
                                        placeHolder="Full Report"
                                        onChange={(data)=>{setSelectedModulePdfoption(data.value)}}
                                        selectedValue={selectedModulePdfOption}
                                        defaultSelectedValue={selectedModulePdfOption}
                                        isMulti = {false}
                                    />
                                </div>
                            </div>
                        </Col>}
                        {downloadFileOption === "excel" && <Col lg={currentPageType === "header" ? 12 : 6}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container">
                                    <p className="mb-1">Excel Options</p>
                                    <DropDown
                                        options={optionsExcel}
                                        placeHolder="Full Report - All Modules"
                                        onChange={excelOptionChange}
                                        selectedValue={selectedModuleOption}
                                        defaultSelectedValue={selectedModuleOption}
                                        dropDownType ={"reportModule"}
                                        isMulti
                                    />
                                </div>
                            </div>
                        </Col>}
                        <div className="form-submit-btn-group mt-5 d-flex align-items-right">
                            <div className={`d-flex gap-3 ${currentPageType === "header" ? "w-100" : "w-25"}`}>
                            {currentPageType === "header" && <Button buttonType={"secondary"} buttonText={"Cancel"} buttonClicked={closeDownloadReport}/>}
                            {!downloadLoading && <Button buttonType={"primary"} buttonText={"Download Report"} buttonClicked={downloadReport} disableButton={checkButtonDisable()}/>}
                            {downloadLoading && <Button buttonType={"primary"} buttonText={"Loading..."} disableButton={true}/>}
                            </div>
                        </div>
                    </Row>
                </motion.div>
            </div>
        </>
    );
}

export default ExposureManagementReports;
